import React, { Component } from 'react';
import ModalBase from '../ModalBase';

class ModalDetalheConteudo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fullScreen: false
        }

        this.onToggleFullscreen = this.onToggleFullscreen.bind(this);
    }

    difficultyLabel(idDifficulty){
        let label = "Difícil";
        if(idDifficulty === 1){
            label ="Fácil";
        }if(idDifficulty === 2){
            label ="Intermediário";
        }
        return label;
    }

    onToggleFullscreen(value) {
        this.setState({ fullScreen: value });
    }
    // componentDidMount() {
    //     console.log('componentDidMount componentDidMount')
    // }

    disciplinesJoin(disciplinesArr){
        let disciplines = JSON.parse(disciplinesArr)
        let label = []
        for(let i in disciplines){
            label.push(disciplines[i].txDiscipline)
        }
        return label.join(' ');
    }

    skillJoin(skillsArr){
        let skills =JSON.parse(skillsArr)
        let label = []
        for(let i in skills){
           label.push(skills[i].txAbility)
        }
       return label;
    }

    getUrlLivro(uri){
        return `${process.env.REACT_APP_LIVROS}${uri}`;
    }

    render() {
        console.log('this.props.study',this.props.study);
        let disciplinesLabel = this.props.study.disciplines && this.disciplinesJoin(this.props.study.disciplines)
        let skills = this.props.study.abilities && this.skillJoin(this.props.study.abilities)
        let difficultyLabel = this.props.study.inDifficultyLevel && this.difficultyLabel(this.props.study.inDifficultyLevel)

        return (<ModalBase {...this.props}
            showFullScreenButtons={true}
            fullScreen={this.state.fullScreen}
            onToggleFullscreen={this.onToggleFullscreen}
            content={
                <div className="edb-padding-large conteudo-container edb-padding-xlarge-bottom">
                    <div>
                        <h3 className="edb-inline">{this.props.study.txStudy}</h3>
                        <div className="edb-small adap-green edb-tag edb-round edb-padding-small edb-margin-small-left">{this.props.study.txMaterialType}</div>
                    </div>

                    <div>
                        <small>{difficultyLabel} | {disciplinesLabel}</small>
                    </div>


                    <div>
                        <i className="fas fa-exclamation-triangle adap-text-red edb-margin-small-right"></i>
                        <strong className="edb-margin-small-right">{this.props.study.pcDeficiency}</strong>
                        dos seus alunos estão com deficiência nesta área.
                    </div>

                    <div className="edb-margin-small-top">
                        <strong>Habilidades:</strong>
                        {skills && skills.map((skill,index)=>
                            <div key={`skill-${index}`}>{skill}</div>
                        )}
                    </div>

                    <iframe title="conteúdo" src={this.getUrlLivro("/b.html")+"?r="+encodeURI(this.getUrlLivro(this.props.study.txPath)+"&s="+document.cookie.replace(/(?:(?:^|.*;\s*)session\s*=\s*([^;]*).*$)|^.*$/, "$1"))}></iframe>

                    {!this.props.hideAdd && <div className="edb-row edb-margin-top edb-padding-small">
                        <div className="edb-col l1">&nbsp;</div>
                        <div className="edb-col l10">
                            <div className="adap-input-icon-container edb-center">
                                <button className="edb-button adap-green" onClick={() => this.props.onClickAddConteudo(this.props.study.idStudy)}><i className="fas fa-plus-circle edb-text-white edb-large edb-margin-small"></i> Criar Estudo</button>
                            </div>
                        </div>
                    </div>}

{/*
                    {!this.props.hideAdd && <button className="edb-button edb-round adap-green edb-display-bottomright edb-margin-large-right edb-margin-bottom adap-modal-step-btn-next"
                        onClick={this.props.onClickAddConteudo}>
                        <i className="fas fa-plus edb-margin-small-right"></i>
                        Adicionar conteúdo</button>} */}
                </div>
            } />);
    }
}

export default ModalDetalheConteudo;